var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"google-map"},[_c('google-map',{attrs:{"locationList":_vm.list,"latLng":_vm.latLng},on:{"center":_vm.onCenter,"zoom":_vm.onZoom,"setItem":_vm.onSetItem,"onmap":function($event){_vm.show = false}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }